"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, FC, PropsWithChildren, useContext } from "react";
import { getImageComponent, getLinkComponent, ReactUIConfig } from "../../config";
const ReactUIConfigContext = createContext<ReactUIConfig>({});
ReactUIConfigContext.displayName = "ReactUIConfig";
export const useLinkComponent = () => {
  return useContext(ReactUIConfigContext).linkComponent ?? getLinkComponent();
};
export const useImageComponent = () => {
  return useContext(ReactUIConfigContext).imageComponent ?? getImageComponent();
};
const ReactUIProvider: FC<PropsWithChildren<ReactUIConfig>> = t0 => {
  const $ = _c(6);
  const {
    children,
    linkComponent,
    imageComponent
  } = t0;
  let t1;
  if ($[0] !== imageComponent || $[1] !== linkComponent) {
    t1 = {
      linkComponent,
      imageComponent
    };
    $[0] = imageComponent;
    $[1] = linkComponent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== t1) {
    t2 = <ReactUIConfigContext.Provider value={t1}>{children}</ReactUIConfigContext.Provider>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default ReactUIProvider;